(() => {
  const desktopMedia = window.matchMedia('(min-width: 990px)');

  const closeMenu = (details, restoreFocus = false) => {
    details.removeAttribute('open');
    const toggle = details.querySelector(':scope > summary');
    toggle?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) {
      const collectionLink = details.closest('.mega-menu-custom__wrapper')?.querySelector(':scope > a');
      (collectionLink || toggle)?.focus();
    }
  };

  const closeOtherMenus = (currentMenu) => {
    document.querySelectorAll('details.mega-menu[open]').forEach((details) => {
      if (details !== currentMenu) closeMenu(details);
    });
  };

  document.querySelectorAll('.mega-menu-custom__wrapper').forEach((wrapper) => {
    const details = wrapper.querySelector(':scope > details.mega-menu-custom');
    if (!details) return;
    const toggle = details.querySelector(':scope > summary');
    let closeTimer;

    const openMenu = () => {
      if (!desktopMedia.matches) return;
      window.clearTimeout(closeTimer);
      closeOtherMenus(details);
      details.setAttribute('open', '');
      toggle?.setAttribute('aria-expanded', 'true');
    };

    const scheduleClose = () => {
      if (!desktopMedia.matches) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!wrapper.matches(':hover') && !wrapper.contains(document.activeElement)) {
          closeMenu(details);
        }
      }, 140);
    };

    wrapper.addEventListener('mouseenter', openMenu);
    wrapper.addEventListener('mouseleave', scheduleClose);
    wrapper.addEventListener('focusin', openMenu);
    wrapper.addEventListener('focusout', scheduleClose);
    details.addEventListener('toggle', () => {
      toggle?.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });
    details.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !details.open) return;
      event.preventDefault();
      closeMenu(details, true);
    });
  });
})();
